<script lang="ts">
    export let elevation:'elevation1'|'elevation2'|'elevation3'|'elevation4'|'elevation5' = 'elevation1';
</script>
<div class="Paper {elevation}">
    <slot />
</div>

<style type="text/scss">
    .Paper {
        @import "../../scss/config.scss";
        border-radius: 4px;
        background-color: $color-white;
        padding: 30px;
        margin-bottom: 30px;
    }
</style>
